const toRadians = (degrees) => (Number(degrees) * Math.PI) / 180;

const pointDistanceMeters = (a, b) => {
  const radius = 6371000;
  const dLat = toRadians(Number(b?.lat) - Number(a?.lat));
  const dLon = toRadians(Number(b?.lon ?? b?.lng) - Number(a?.lon ?? a?.lng));
  const latA = toRadians(a?.lat);
  const latB = toRadians(b?.lat);
  const value =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(latA) * Math.cos(latB) * Math.sin(dLon / 2) ** 2;
  return 2 * radius * Math.asin(Math.sqrt(value));
};

export function filterPointsByNodes(nodes, points, minMeters) {
  if (!Array.isArray(points) || !points.length) return [];
  if (!Array.isArray(nodes) || !nodes.length) return points;
  const threshold = Math.max(1, Number(minMeters) || 0);
  // Indexar os nós em células evita comparar cada ponto importado com toda a
  // grelha. Com milhares de nós, a pesquisa anterior O(pontos × nós) prendia
  // a interface durante a importação de GPX relativamente pequenos.
  const allLatitudes = nodes
    .map((node) => Number(node?.lat))
    .filter(Number.isFinite);
  const referenceLat = allLatitudes.length
    ? allLatitudes.reduce((sum, value) => sum + value, 0) / allLatitudes.length
    : 40;
  const latCell = threshold / 111320;
  const lonCell = threshold / Math.max(20000, 111320 * Math.cos(toRadians(referenceLat)));
  const buckets = new Map();
  const cellKey = (latIndex, lonIndex) => `${latIndex}:${lonIndex}`;
  nodes.forEach((node) => {
    const lat = Number(node?.lat);
    const lon = Number(node?.lon ?? node?.lng);
    if (!Number.isFinite(lat) || !Number.isFinite(lon)) return;
    const latIndex = Math.floor(lat / latCell);
    const lonIndex = Math.floor(lon / lonCell);
    const key = cellKey(latIndex, lonIndex);
    const bucket = buckets.get(key);
    if (bucket) bucket.push(node);
    else buckets.set(key, [node]);
  });
  return points.filter((point, index) => {
    // Primeiro e último pontos são escolhas explícitas e definem as ligações
    // topológicas do trecho. A desduplicação só pode remover pontos interiores.
    if (index === 0 || index === points.length - 1) return true;
    const lat = Number(point?.lat);
    const lon = Number(point?.lon ?? point?.lng);
    if (!Number.isFinite(lat) || !Number.isFinite(lon)) return false;
    const latIndex = Math.floor(lat / latCell);
    const lonIndex = Math.floor(lon / lonCell);
    for (let latOffset = -1; latOffset <= 1; latOffset += 1) {
      for (let lonOffset = -1; lonOffset <= 1; lonOffset += 1) {
        const bucket = buckets.get(cellKey(latIndex + latOffset, lonIndex + lonOffset));
        if (bucket?.some((node) => pointDistanceMeters(node, point) <= threshold)) {
          return false;
        }
      }
    }
    return true;
  });
}
